/* Importaciones de React */
import React, { useState, useEffect, useCallback } from 'react'

/* Importaciones de MUI */
import { Stack, Typography, TextField, InputAdornment, Button, CircularProgress, Paper, Box } from '@mui/material'
import { Person, Numbers, Phone } from '@mui/icons-material'

/* Importaciones del modulo de Shared */
import { ModalView } from '../../Shared'

export default function CostumerForm({ displayState, addCart, setCreatingQuote }) {
  /* Estados */
  const [show, setShow] = displayState
  const [costumerName, setCostumerName] = useState('')
  const [costumerPhone, setCostumerPhone] = useState('')
  const [validForm, setValidForm] = useState(true)
  const [loadingPending, setLoadingPending] = useState(false)
  const [previousCarts, setPreviousCarts] = useState([])

  const clearForm = useCallback(() => {
    setCostumerName('')
    setCostumerPhone('')
    setPreviousCarts([])
  }, [])

  useEffect(() => {
    const isNameValid = costumerName.trim().length >= 3
    const isPhoneValid = costumerPhone === '' || costumerPhone.length === 10

    if (isNameValid && isPhoneValid) {
      setValidForm(true)
    } else {
      setValidForm(false)
    }
  }, [costumerName, costumerPhone])

  useEffect(() => {
    const permissions = JSON.parse(sessionStorage.getItem('permissions'))
    const isPDV = ['Admin', 'PDV', 'Supervisor'].includes(permissions?.role)

    if (isPDV && costumerPhone.length === 10) {
      setLoadingPending(true)
      const localhost = sessionStorage.getItem('localhost')
      const token = sessionStorage.getItem('token')

      fetch(`${localhost}/api/v2/cart/previous/${costumerPhone}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache'
        }
      })
        .then(res => res.json())
        .then(data => {
          if (data && data.carts) {
            setPreviousCarts(data.carts)
          }
        })
        .catch(err => console.error('Error fetching previous carts:', err))
        .finally(() => setLoadingPending(false))
    } else {
      setPreviousCarts([])
    }
  }, [costumerPhone])

  /* Componente */
  return (
    <ModalView
      displayState={displayState}
      width={'32%'}
      maxHeight={'85%'}
    >
      <Stack
        direction='column'
        spacing={2}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 700,
            textAlign: 'center'
          }}
        >
          Complete los campos para abrir un nuevo carrito
        </Typography>

        <TextField
          label={'Nombre completo del cliente'}
          placeholder={'Alejandro Gomez Torres'}
          value={costumerName}
          onChange={event => setCostumerName(event.target.value.replace(/[^a-zA-Z ]/g, ''))}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Person color='primary' />
              </InputAdornment>
            )
          }}
          fullWidth
          focused
          required
        />

        <TextField
          label={'Numero de Telefono'}
          placeholder={'##########'}
          value={costumerPhone}
          onChange={event => setCostumerPhone(event.target.value.replace(/[^0-9]/g, '').slice(0, 10))}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Phone color='primary' />
              </InputAdornment>
            )
          }}
          fullWidth
          focused
        />

        {loadingPending && (
          <CircularProgress
            size={24}
            sx={{ my: 1, alignSelf: 'center' }}
          />
        )}

        {!loadingPending && previousCarts.length > 0 && (
          <Stack
            spacing={1}
            sx={{ mt: 1, p: 1.5, border: '1px solid rgba(255, 87, 34, 0.3)', borderRadius: 2, bgcolor: 'action.hover' }}
          >
            <Typography sx={{ fontSize: '12px', color: 'primary.main', fontWeight: 700 }}>Carritos previos encontrados ({previousCarts.length}):</Typography>
            <Stack
              spacing={1}
              sx={{ maxHeight: 180, overflowY: 'auto' }}
            >
              {previousCarts.map((item, idx) => {
                const waybillCount = item.waybills?.length || 0
                const deliveryCount = item.deliveries?.length || 0
                const productCount = item.products?.length || 0
                const firstItem = item.waybills?.[0] || item.deliveries?.[0]
                const routePreview = firstItem ? `${firstItem.origenMunicipio || firstItem.origenEstado || 'S/O'} ➔ ${firstItem.destinoMunicipio || firstItem.destinoEstado || 'S/D'}` : ''

                return (
                  <Paper
                    key={idx}
                    variant='outlined'
                    sx={{ p: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontSize: '11px', fontWeight: 700 }}>
                        Folio: {item.folio || item.uuid.substring(0, 8)} - {item.costumer?.name || ''}
                      </Typography>
                      {routePreview && <Typography sx={{ fontSize: '9.5px', color: 'primary.main', fontWeight: 600, my: 0.5 }}>{routePreview}</Typography>}
                      <Typography sx={{ fontSize: '10px', color: 'text.secondary', fontWeight: 500 }}>
                        {waybillCount > 0 && `Guías: ${waybillCount}  `}
                        {deliveryCount > 0 && `Envíos: ${deliveryCount}  `}
                        {productCount > 0 && `Productos: ${productCount}`}
                      </Typography>
                      <Typography sx={{ fontSize: '10px', color: 'text.secondary' }}>Monto: ${Number(item.monto).toFixed(2)}</Typography>
                      <Typography sx={{ fontSize: '9px', color: 'text.secondary' }}>Creado: {item.created_at}</Typography>
                    </Box>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={async () => {
                        setCreatingQuote(true)
                        await addCart({ name: item.costumer.name || costumerName, phone: costumerPhone }, item)
                        setCreatingQuote(false)
                        clearForm()
                        setShow(false)
                      }}
                      sx={{ fontSize: '10px', p: '2px 8px', alignSelf: 'center' }}
                    >
                      Duplicar
                    </Button>
                  </Paper>
                )
              })}
            </Stack>
          </Stack>
        )}
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='right'
        sx={{ mt: 2 }}
      >
        <Button
          onClick={() => {
            if (validForm) {
              setCreatingQuote(true)
              addCart({ name: costumerName, phone: costumerPhone })
              setCreatingQuote(false)
              clearForm()
              setShow(false)
              return
            }

            alert('Ingrese Nombre 3 caracteres o mas y Telefono 10 digitos')
          }}
          sx={{ fontSize: '12.4px' }}
        >
          Agregar cliente y crear carrito
        </Button>

        <Button
          onClick={() => {
            clearForm()
            setShow(false)
          }}
          sx={{ fontSize: '12.4px' }}
        >
          Cerrar
        </Button>
      </Stack>
    </ModalView>
  )
}
